// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content-sidebar_leftBlock__mcYiF {
    width: 25%;
    background: var(--color-content-sidebar);
    color: var(--color-main-typography);
    padding: 36px 30px;
    min-height: 100vh;
    position: relative;
}

.content-sidebar_leftBlockTop__MbzTJ {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 40px;
}

.content-sidebar_leftBlockList__0ufbg {
    width: 100%;

}

.content-sidebar_addView__0G3bs {
    width: 44px;
    height: 44px;
    border-radius: 5px;
    background: var(--color-content-highlight);
    border: unset;
}

.content-sidebar_addViewIcon__j0o1o {
    width: 24px;
    height: 24px;
    background-color: var(--color-content-highlight);
}

.content-sidebar_sidebar-controls__wCMMH {
    display: none;
}

.content-sidebar_menu-contaner__7TZID {
    width: 100%;
}

.content-sidebar_content-contaner__A1WoX {
    padding: 0;
}

@media screen and (max-width: 1000px) {

    .content-sidebar_dropdown-container__F1qkf {
        position: absolute;
        width: 205px;
        right: 15px;
        top: 60px;
    }
    
    .content-sidebar_leftBlock__mcYiF {
        width: 100%;
        background: var(--color-content-sidebar);
        color: var(--color-main-typography);
        min-height: 100vh;
        position: absolute;
        right: 0;
        padding: 0;
    }

    .content-sidebar_content-contaner__A1WoX {
        padding: 36px 30px;
    }

    .content-sidebar_sidebar-controls__wCMMH {
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        position: absolute;
        top: 10px;
        left: 10px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/content-sidebar/content-sidebar.module.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,wCAAwC;IACxC,mCAAmC;IACnC,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,WAAW;;AAEf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,0CAA0C;IAC1C,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gDAAgD;AACpD;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,UAAU;AACd;;AAEA;;IAEI;QACI,kBAAkB;QAClB,YAAY;QACZ,WAAW;QACX,SAAS;IACb;;IAEA;QACI,WAAW;QACX,wCAAwC;QACxC,mCAAmC;QACnC,iBAAiB;QACjB,kBAAkB;QAClB,QAAQ;QACR,UAAU;IACd;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,aAAa;QACb,uBAAuB;QACvB,2BAA2B;QAC3B,kBAAkB;QAClB,SAAS;QACT,UAAU;IACd;AACJ","sourcesContent":[".leftBlock {\n    width: 25%;\n    background: var(--color-content-sidebar);\n    color: var(--color-main-typography);\n    padding: 36px 30px;\n    min-height: 100vh;\n    position: relative;\n}\n\n.leftBlockTop {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 40px;\n}\n\n.leftBlockList {\n    width: 100%;\n\n}\n\n.addView {\n    width: 44px;\n    height: 44px;\n    border-radius: 5px;\n    background: var(--color-content-highlight);\n    border: unset;\n}\n\n.addViewIcon {\n    width: 24px;\n    height: 24px;\n    background-color: var(--color-content-highlight);\n}\n\n.sidebar-controls {\n    display: none;\n}\n\n.menu-contaner {\n    width: 100%;\n}\n\n.content-contaner {\n    padding: 0;\n}\n\n@media screen and (max-width: 1000px) {\n\n    .dropdown-container {\n        position: absolute;\n        width: 205px;\n        right: 15px;\n        top: 60px;\n    }\n    \n    .leftBlock {\n        width: 100%;\n        background: var(--color-content-sidebar);\n        color: var(--color-main-typography);\n        min-height: 100vh;\n        position: absolute;\n        right: 0;\n        padding: 0;\n    }\n\n    .content-contaner {\n        padding: 36px 30px;\n    }\n\n    .sidebar-controls {\n        display: flex;\n        align-items: flex-start;\n        justify-content: flex-start;\n        position: absolute;\n        top: 10px;\n        left: 10px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"leftBlock": `content-sidebar_leftBlock__mcYiF`,
	"leftBlockTop": `content-sidebar_leftBlockTop__MbzTJ`,
	"leftBlockList": `content-sidebar_leftBlockList__0ufbg`,
	"addView": `content-sidebar_addView__0G3bs`,
	"addViewIcon": `content-sidebar_addViewIcon__j0o1o`,
	"sidebar-controls": `content-sidebar_sidebar-controls__wCMMH`,
	"menu-contaner": `content-sidebar_menu-contaner__7TZID`,
	"content-contaner": `content-sidebar_content-contaner__A1WoX`,
	"dropdown-container": `content-sidebar_dropdown-container__F1qkf`
};
export default ___CSS_LOADER_EXPORT___;
